import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId, waLink, PHONE_DISPLAY } from "../../lib/contact";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="py-28 sm:py-36 bg-navy relative overflow-hidden">
    <div className="absolute inset-0 bg-grid-navy" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full bg-electric/15 blur-[160px]" />
    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-cyanx">Limited Seats Available</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12]">
          Don't Just Learn Digital Tools.
          <span className="block text-gradient mt-2">Learn How a Business Works.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-6 text-base sm:text-lg text-slate-400 max-w-2xl mx-auto leading-relaxed">
          Join the 45-Day Practical Online Business Program and explore the skills, systems and tools used to launch and operate modern online businesses.
        </p>
      </Reveal>
      <Reveal delay={0.24}>
        <p className="mt-6 text-sm font-semibold tracking-wide text-slate-300">45 Days · Offline Classroom · Practical Project · ₹14,999</p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <button
            data-testid="final-cta-book"
            onClick={() => scrollToId("contact")}
            className="group inline-flex items-center gap-2 bg-electric hover:bg-electric-dark text-white font-semibold text-sm rounded-full px-8 py-4 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-electric/40"
          >
            Book Free Counselling
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            data-testid="final-cta-whatsapp"
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 border border-white/20 hover:border-cyanx/60 text-slate-200 font-semibold text-sm rounded-full px-8 py-4 transition-colors"
          >
            <MessageCircle size={16} /> Call / WhatsApp: {PHONE_DISPLAY}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
